import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import SkeletonTable from '../../Common/SkeletonTable';

const ReportListView = ({ reportedAdsRows, loading, handleSort, orderBy, orderByDir }) => {
  // Define skeleton table columns
  const skeletonColumns = [
    { title: 'Property Title', width: 150 },
    { title: 'Reason', width: 100 },
    { title: 'Comment', width: 120 },
    { title: 'Reported By Name', width: 100 },
    { title: 'Reported By Phone', width: 120 },
    { title: 'Reported By Email', width: 140 },
    { title: 'Reported Date', width: 120 },
    { title: 'Action', width: 80, height: 32 }
  ];

  if (loading) {
    return <SkeletonTable columns={skeletonColumns} rows={8} />;
  }

  return (
    <div className='table-responsive table-hover fs-14 order-list-table'>
      <table className='table display table-hover display mb-4 dataTablesCard card-table dataTable no-footer'>
        <thead>
          <tr role='row'>
            <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('propertyId.title')}>
              Property Title
              <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                <i className="fa fa-caret-up" style={{ color: orderBy === 'propertyId.title' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'propertyId.title' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                <i className="fa fa-caret-down" style={{ color: orderBy === 'propertyId.title' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'propertyId.title' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
              </span>
            </th>
            <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('reason')}>
              Reason
              <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                <i className="fa fa-caret-up" style={{ color: orderBy === 'reason' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'reason' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                <i className="fa fa-caret-down" style={{ color: orderBy === 'reason' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'reason' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
              </span>
            </th>
            <th>Comment</th>
            <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('userId.name')}>
              Reported By Name
              <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                <i className="fa fa-caret-up" style={{ color: orderBy === 'userId.name' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'userId.name' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                <i className="fa fa-caret-down" style={{ color: orderBy === 'userId.name' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'userId.name' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
              </span>
            </th>
            <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('userId.phone')}>
              Reported By Phone
              <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                <i className="fa fa-caret-up" style={{ color: orderBy === 'userId.phone' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'userId.phone' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                <i className="fa fa-caret-down" style={{ color: orderBy === 'userId.phone' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'userId.phone' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
              </span>
            </th>
            <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('userId.email')}>
              Reported By Email
              <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                <i className="fa fa-caret-up" style={{ color: orderBy === 'userId.email' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'userId.email' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                <i className="fa fa-caret-down" style={{ color: orderBy === 'userId.email' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'userId.email' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
              </span>
            </th>
            <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('createdAt')}>
              Reported Date
              <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                <i className="fa fa-caret-up" style={{ color: orderBy === 'createdAt' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'createdAt' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                <i className="fa fa-caret-down" style={{ color: orderBy === 'createdAt' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'createdAt' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
              </span>
            </th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {reportedAdsRows.map((item) => (
            <tr key={item._id}>
              <td>{item.propertyId?.title || 'N/A'}</td>
              <td>
                <span className={`badge badge-${
                  item.reason === 'Offensive content' ? 'danger' :
                  item.reason === 'fraud' ? 'danger' :
                  item.reason === 'Duplicate ad' ? 'info' :
                  item.reason === 'Product already sold' ? 'warning' :
                  'secondary'
                }`}>
                  {item.reason === 'Offensive content' ? 'Offensive Content' :
                   item.reason === 'Duplicate ad' ? 'Duplicate Ad' :
                   item.reason === 'Product already sold' ? 'Product Already Sold' :
                   item.reason?.charAt(0).toUpperCase() + item.reason?.slice(1) || 'N/A'}
                </span>
              </td>
              <td>
                <div style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.comment}>
                  {item.comment}
                </div>
              </td>
              <td>{item.userId?.name || 'N/A'}</td>
              <td>{item.userId?.phone || 'N/A'}</td>
              <td>{item.userId?.email || 'N/A'}</td>
              <td>{moment(item.createdAt).format("DD/MM/YYYY, hh:mm A")}</td>
              <td>
                <div className="d-flex">
                  <Link to={`/property-details/${item.propertyId?._id}?nfrm=rptd`} className="btn btn-secondary btn-sm shadow me-2">
                    <i className="fa fa-eye me-1"></i>
                    View
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportListView;